/**
 * Simple `Array.fromAsync` implementation.
 * @param iterable Iterable to transform into an array.
 * @returns Promise containing an array with all the elements in the iterable.
 */
export async function arrayFromAsync<T>(
  iterable: Iterable<T> | AsyncIterable<T>,
): Promise<T[]> {
  const array = [];
  for await (const el of iterable) {
    array.push(el);
  }
  return array;
}
